module.exports = __webpack_public_path__ + "static/ConsumerSignUp3-1831ea1cdf699afa42ac984156706f4f.png";